import { Button, Icon } from '@arkas/coreui';
import { MenuItemDto } from '@emutabakat-types/app';
import { NavLink } from 'react-router-dom';
import React from 'react';

interface CustomMenuSubMenuProps {
  subMenuItems: MenuItemDto[];
  togglePopOver: Function;
}

interface CustomMenuSubMenuStates {
  menuItems: MenuItemDto[];
  prevItems: MenuItemDto[][] | undefined;
  selectedTitles: React.ReactNode[];
}

/**
 * CustomMenuSubMenu Component
 */
class CustomMenuSubMenu extends React.Component<
  CustomMenuSubMenuProps,
  CustomMenuSubMenuStates
> {
  constructor(props: CustomMenuSubMenuProps) {
    super(props);
    this.state = {
      menuItems: props.subMenuItems,
      prevItems: [],
      selectedTitles: []
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  wrapperRef: HTMLUListElement | undefined;

  setWrapperRef = (node: HTMLUListElement) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event: MouseEvent) => {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target as HTMLElement)
    ) {
      this.resetMenuItems();
    }
  };

  resetMenuItems() {
    const { subMenuItems } = this.props;
    this.setState({
      menuItems: subMenuItems,
      prevItems: [],
      selectedTitles: []
    });
  }

  togglePopOver = () => {
    const { togglePopOver } = this.props;
    togglePopOver();
    this.resetMenuItems();
  };

  getSubItems = (item: MenuItemDto, currentItems: MenuItemDto[]) => () => {
    const { prevItems, selectedTitles } = this.state;
    this.setState({
      menuItems: item.items as MenuItemDto[],
      prevItems: prevItems ? [...prevItems, currentItems] : [currentItems],
      selectedTitles: [...selectedTitles, item.title]
    });
  };

  getPrevItems = () => {
    const { prevItems, selectedTitles } = this.state;

    if (prevItems) {
      const lastPrevItems = prevItems.pop();
      selectedTitles.pop();
      if (lastPrevItems) {
        this.setState({
          menuItems: lastPrevItems,
          prevItems,
          selectedTitles
        });
      }
    }
  };

  render() {
    const { menuItems, prevItems, selectedTitles } = this.state;

    return (
      <ul
        ref={this.setWrapperRef}
        style={{ listStyle: 'none', paddingLeft: 0, margin: 0 }}
      >
        {prevItems &&
          prevItems.length > 0 && (
            <li style={{ textAlign: 'left' }}>
              <Button
                ghost={true}
                onClick={this.getPrevItems}
                style={{ border: 'none', width: 37, textOverflow: 'initial' }}
              >
                <Icon type={'left'} style={{ fontSize: 10 }} />
              </Button>
              <span className="custom-menu-dropdown-selected-title">
                {selectedTitles[selectedTitles.length - 1]}
              </span>
            </li>
          )}
        {menuItems.map((item, j) => (
          <li key={j.toString()}>
            {item.items && item.items.length > 0 ? (
              <Button
                className={!item.icon ? 'no-icon' : ''}
                ghost={true}
                style={{
                  width: '100%',
                  border: 'none',
                  textAlign: 'left',
                  lineHeight: '10px'
                }}
                onClick={this.getSubItems(item, menuItems)}
              >
                <Icon
                  type="right"
                  style={{ fontSize: 10, float: 'right', paddingLeft: 12 }}
                />
                {item.icon && <Icon type={item.icon} />}
                {item.title}
              </Button>
            ) : (
              <NavLink to={item.url as string}>
                <Button
                  icon={item.icon}
                  className={!item.icon ? 'no-icon' : ''}
                  onClick={this.togglePopOver}
                  ghost={true}
                  style={{ width: '100%', border: 'none', textAlign: 'left' }}
                >
                  {item.title}
                </Button>
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    );
  }
}

export default CustomMenuSubMenu;
